import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtService } from 'app/generic/JwtService';
import { NewModalService } from 'app/generic/new-modal/new-modal.service';
import { environment } from 'environments/environment';

@Injectable()
export class TaAllertaDownloadService extends JwtService {

  constructor(private http: HttpClient, public router: Router, public modalService: NewModalService) { super(router, modalService); }

  selectAll(): Promise<any> {
    return this.http.get(environment.apiEndpoint + '/CentroFunzionalePortaleRest/rest/bollettinometeo/findAll/', super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));
  }

  selectAllByAnno(anno: number): Promise<any> {

    return this.http.get(environment.apiEndpoint + '/CentroFunzionalePortaleRest/rest/bollettinometeo/findAllByAnno/' + anno, super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));
  }

  selectAllDaA(inizio: number, fine: number): Promise<any> {

    return this.http.get(environment.apiEndpoint + '/CentroFunzionalePortaleRest/rest/bollettinometeo/findAllDaA/' + inizio + '/' + fine, super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));
  }


  findByIdBollettino(idBollettino: any): Promise<any> {
    return this.http.get(environment.apiEndpoint + '/CentroFunzionalePortaleRest/rest/bollettinometeo/findByIdBollettino/' + idBollettino, super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));
  }

  getPDFbyte(idBollettino: any): Promise<any> {
    return this.http.get(environment.apiEndpoint + '/CentroFunzionalePortaleRest/rest/bollettinometeo/getPDF/' + idBollettino, super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));
  }

  // avviso 
  findLastBollettinoInserito(): Promise<any> {
    return this.http.get(environment.apiEndpoint + '/CentroFunzionalePortaleRest/rest/bollettinometeo/findLastBollettinoInserito/', super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));
  }
  // bollettino 
  findLastMeteo(): Promise<any> {
    return this.http.get(environment.apiEndpoint + '/CentroFunzionalePortaleRest/rest/previsionimeteo/findLastMeteo/', super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));
  }

}
